import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getNameInitialsFromFullName } from '../../core/util/string';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';

const StyledOption = styled.div`
  padding-left: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
  border-top: 1px solid ${colors.borderLine};
  font-family: ${fontFamily.book};
  cursor: pointer;
  color: ${colors.blueMonday};
  &:hover {
    background-color: ${colors.whiteGrey};
    color: ${colors.blueMonday};
  }
  ${props => css`
    background-color: ${props.selected && colors.blueJayWay};
    color: ${props.selected && 'white'};
  `}
  ${props => css`
    &:hover {
      background-color: ${props.selected && colors.blueJayWay};
      color: ${props.selected && 'white'};
    }
  `}
`;

const NameContainer = styled.div`
  background-color: ${colors.blueJayWay};
  ${props => css`
    background-color: ${props.color.primary};
  `};
  border-radius: 50%;
  color: ${colors.white};
  height: 30px;
  margin-right: 15px;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  width: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: ${fontSize.mediumSmall};
`;

class SelectOption extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired,
  };

  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = event => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };

  render() {
    const { isSelected, color } = this.props.option;
    const fullName =
      typeof this.props.children === 'string'
        ? this.props.children
        : this.props.children.props.children;
    return (
      <StyledOption
        selected={isSelected}
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <NameContainer color={color}>{getNameInitialsFromFullName(fullName, '')}</NameContainer>
        {fullName}
      </StyledOption>
    );
  }
}

export default SelectOption;
